<template>
	<div class="container page">
		<div class="page__info">
			<div class="page__info--title">
				Browse Deal Links
			</div>
			<V2Button class="page__info--btn" to="/teaching/links/create">
				Create Link
			</V2Button>
		</div>

		<div class="links-list">
			<deal-links-list
				v-if="getLinks"
				:links="getLinks"
				:filters="getFilterOptions"
				:pagination="getPagination"
				:totalItems="getTotalItems"
				:showClearFilters="true"
				@search="onSearch"
				@filter="onFilter"
				@paginate="onPaginate"
			/>
		</div>
	</div>
</template>

<script>
	import V2Button from '@/components/v2/ui/V2Button';
	import DealLinksList from '@/components/dealLinks/DealLinksList';
	import api from '@/services/api';

	export default {
		metaInfo: {
			title: 'Deal Links'
		},
		layout: 'v2default',
		components: {
			DealLinksList,
			V2Button
		},
		data () {
			return {
				links: [],
				searchString: '',
				currentPage: 1,
				perPage: 15,
				numPages: 1,
				totalItems: 0
			};
		},
		computed: {
			getBreadcrumbs () {
				return [
					{
						path: '/teaching',
						text: 'Teaching'
					},
					{
						path: '/teaching/links',
						text: 'Deal Links'
					}
				];
			},
			getLinks () {
				return this.links || false;
			},
			getFilterOptions () {
				return [];
			},
			getPagination () {
				return {
					perPage: this.perPage,
					currentPage: this.currentPage,
					totalPages: this.numPages
				};
			},
			getTotalItems () {
				return this.totalItems;
			}
		},
		created () {
			this.setLinks();
		},
		methods: {
			async setLinks () {
				try {
					const response = await api.dealLinks.getDealLinks({
						searchString: this.searchString,
						page: this.currentPage,
						per: this.perPage
					});

					if (response) {
						this.numPages = response.meta.numPages;
						this.totalItems = response.meta.totalItems;
						this.links = response.results;
					}
				} catch (err) {
					console.log(err);
				} finally {
					this.$store.commit('ui/setBreadcrumbs', {
						breadcrumbs: this.getBreadcrumbs
					});
					this.$store.commit('ui/setLoadingIsHidden');
				}
			},
			onFilter (_value) {
			},
			onSearch (value) {
				this.searchString = value;
				this.setLinks();
			},
			onPaginate (value) {
				this.currentPage = value;
				this.setLinks();
			}
		}
	};
</script>

<style lang="scss" scoped>
.page {
  &__info {
    display: flex;
    justify-content: space-between;
		align-items: center;
    flex-direction: row;

    &--title {
      width: fit-content;
    }

    &--btn {
      width: fit-content;
			white-space: nowrap;
    }
  }

	.links-list {
		margin: rem(24) 0 0;
	}
}
</style>
